import React, { useState, useEffect, forwardRef, useRef } from 'react'
import axios from "axios";
import { Auth } from "aws-amplify";
import { AlertTitle, AppBar, Button, CircularProgress, Dialog, Divider, FormControl, InputLabel, MenuItem, Select, Slide, Tab, Tabs, TextField } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { useTranslation } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';
import AssessmentIcon from '@mui/icons-material/Assessment';
import GroupsIcon from "@mui/icons-material/Groups";

import StudentReport from './StudentReport';
import Table from '../../TableComponent';

// Dialogue
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const orderBy = ["orgStudId", "rated", "enWcpm", "hiWcpm", "enAccuracy", "hiAccuracy"]

const StudentRating = ({ expertInfo }) => {
  const [tabValue, setTabValue] = useState(0);
  const [testId, setTestId] = useState(expertInfo.allTests ? expertInfo.allTests[0].testId : null)
  const [lang, setLang] = useState( expertInfo.allTests ? expertInfo.allTests[0].lang.sort()[0] : "");
  const [studentForm, setStudentForm] = useState({orgStudId: "", classId: ""});
  const [studentFormError, setStudentFormError] = useState({orgStudId: true, classId: true});
  const [studentFormState, setStudentFormState] = useState(false);
  const [reportJson, setReportJson] = useState("");
  const [studentsData, setStudentsData] = useState({})
  const [sortBy, setSortByChange] = useState(orderBy[0])
  // Dialogue
  const maxWidth = "lg"
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const audioRef = useRef([])

  const { t } = useTranslation();
  
  useEffect(() => {
    if(!expertInfo.allTests){
    alert(t("commonItems.error_noTestCompleted"))
    window.location.replace("/");
    }
  }, [t, expertInfo]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleTestIdChange = (e) => {
    setTestId(e.target.value);
  };

  const handleLangChange = (e) => {
    setLang(e.target.value);
  };

  const handleStudentFormChange = (field, value) => {
    // console.log(value)
    setStudentForm(prev => ({...prev, [field]: value}))
    if(field === "orgStudId"){
      // This checks that orgStudId atleast 1 to 32 A to Z a to z and digits & checks for any whitespace character at the start of string
      if((/^(?!\s)([A-Za-z\d]){1,32}$/).test(value)) setStudentFormError(prev => ({...prev, [field]: false}))   // \d is same as 0-9
      else setStudentFormError(prev => ({...prev, [field]: true}))
    }
    if(field === "classId"){
      // This checks that classId atleast 1 to 32 A to Z a to z and digits & checks for any whitespace character at the start of string
      if((/^(?!\s)([A-Za-z\d]){10,32}$/).test(value)) setStudentFormError(prev => ({...prev, [field]: false}))   // \d is same as 0-9
      else setStudentFormError(prev => ({...prev, [field]: true}))
    }
  };

  // fetch students
  const handleFetchStudents = (data) => {
    if(!(/^(?!\s)([A-Za-z\d]){10,32}$/).test(studentForm.classId)) {
      // setToastType(["warning", "Please fill all the required fields!"])
      // setToastOpen(true)
      return
    }
    if(Object.keys(studentsData).includes("students") && studentsData.length !==0 && Number(studentsData.testId) === testId && studentsData.classId === studentForm.classId){
      return
    }
    if(error!=="" && Object.keys(error).includes("classId") && error.testId === testId && error.classId === studentForm.classId){
      return
    }
    setStudentsData({})
    setError("")
    setStudentFormState(true)
    Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        const expertId = data.idToken.payload["custom:db_id"]

        const getStudentsData = async(expertId, testId, classId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/expert/"+expertId+"/students?testId="+testId+"&classId="+classId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log(response.data)
            setStudentsData(response.data)
            setStudentFormState(false)
          }
          catch (error) {
            if([404, 406].includes(error.response.status)) setError({...error.response.data, "testId": testId, "classId": classId})
            else{
              setError({"status": "error", "message": t("commonItems.error_api_generic")})
              console.log(error)
            }
            setStudentFormState(false)
          }
        }

        getStudentsData(expertId, testId, studentForm.classId)
      })
      .catch((err) => console.log(err));
  };

  // Dialogue
  const handleClickOpen = (e) => {
    if(Object.keys(e).includes("orgStudId")){
      if(error!=="" && Object.keys(error).includes("orgStudId") && error.testId === testId && error.orgStudId === e.orgStudId){
        setOpen(true);
        return
      }
      if(reportJson!=="" && Number(reportJson.testId) === testId && (reportJson.studentDetails?.orgStudId === e.orgStudId || reportJson.studentDetails?.id === e.orgStudId)){
        setOpen(true);
        return
      }
    }
    else{
      if(!(/^(?!\s)([A-Za-z\d]){1,32}$/).test(studentForm.orgStudId)) {
        // setToastType(["warning", "Please fill all the required fields!"])
        // setToastOpen(true)
        return
      }
      if(error!=="" && Object.keys(error).includes("orgStudId") && error.testId === testId && error.orgStudId === studentForm.orgStudId){
        setOpen(true);
        return
      }
      if(reportJson!=="" && Number(reportJson.testId) === testId && (reportJson.studentDetails?.orgStudId === studentForm.orgStudId || reportJson.studentDetails?.id === studentForm.orgStudId)){
        setOpen(true);
        return
      }
    }
    setReportJson("")
    setError("")
    setStudentFormState(true)
    setOpen(true);
    Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        const expertId = data.idToken.payload["custom:db_id"]

        const getReportData = async(expertId, testId, orgStudId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/expert/"+expertId+"/student-report?testId="+testId+"&orgStudId="+orgStudId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log(response.data)
            // console.log("Student Report Data: ", {...response.data, "reportCard": response.data.reportCard.sort((a, b) => a.lang > b.lang ? 1 : -1)})
            setReportJson({...response.data, "reportCard": response.data.reportCard.sort((a, b) => a.lang > b.lang ? 1 : -1)})
            setStudentFormState(false)
          }
          catch (error) {
            if([404, 406].includes(error.response.status)) setError({...error.response.data, "testId": testId, "orgStudId": orgStudId})
            else{
              setError({"status": "error", "message": t("commonItems.error_api_generic")})
              console.log(error)
            }
            setStudentFormState(false)
          }
        }

        getReportData(expertId, testId, Object.keys(e).includes("orgStudId") ? e.orgStudId : studentForm.orgStudId)
      })
      .catch((err) => console.log(err));
  };

  const handleClose = () => {
    if(error==="" && audioRef.current.length) audioRef.current.map((audio => audio.pause()))
    setOpen(false);
  };

  const columns = [
    {
      key: "orgStudId",
      headerName: t("commonItems.tableHeader_orgStudId"),
      width: 80
    },
    {
      key: "enWcpm",
      headerName: "WCPM - " + expertInfo.allLangs.EN,
      width: 60,
      tooltip: true
    },
    {
      key: "hiWcpm",
      headerName: "WCPM - " + expertInfo.allLangs.HI,
      width: 60,
      tooltip: true
    },
    {
      key: "enAccuracy",
      headerName: "Accuracy - " + expertInfo.allLangs.EN,
      width: 60,
      percent: true,
      tooltip: true
    },
    {
      key: "hiAccuracy",
      headerName: "Accuracy - " + expertInfo.allLangs.HI,
      width: 60,
      percent: true,
      tooltip: true
    },
    {
      key: "rated",
      headerName: t("expert.rateStudents.tableHeader_rated"),
      width: 60
    },
    {
      key: "testId",
      headerName: t("commonItems.tableHeader_report"),
      width: 60,
      button: {
        "name": t("expert.rateStudents.buttonLabel_viewReport"), 
        "size": "medium",
        "disabled": studentFormState || Object.keys(studentsData).length ===0, 
        "handleClick": handleClickOpen
      }
    }
  ]

  return (
    <div className='innerContent'>
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("expert.rateStudents.title")}
      </h2>
      <AppBar position="static" sx={{mt: "0.5rem", backgroundColor: "#001162"}}>
        <Tabs value={tabValue} onChange={handleTabChange} sx={{minHeight: "30px"}} variant='fullWidth' textColor="inherit" TabIndicatorProps={{style: {backgroundColor: "#7ed46a", height: "4px"}}}>
          <Tab label={t("expert.rateStudents.tabLabel_searchByClassId")} sx={{fontSize: "inherit", minHeight: "30px"}}/>
          <Tab label={t("expert.rateStudents.tabLabel_searchByStudentId")} sx={{fontSize: "inherit", minHeight: "30px"}}/>
        </Tabs>
      </AppBar>
      <div className="filters">
        <div className="forms">
          <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
            <FilterListIcon fontSize="small"/>
            <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
          </h4>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="testNameFilterLabel">{t("commonItems.dropdownLabel_testName")}</InputLabel>
            <Select
              labelId="testIdFilterLabel"
              id="testIdFilter"
              value={testId ? testId : ""}
              onChange={handleTestIdChange}
              autoWidth
              label={t("commonItems.dropdownLabel_testName")}
            >
              {/* <MenuItem value="">
                <em>None</em>
              </MenuItem> */}
              {/* getting all unique std values from data */}
              {expertInfo.allTests &&
                expertInfo.allTests.map(item => item.testName).map((item, i) => {
                return <MenuItem key={i} value={expertInfo.allTests[i].testId}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
            <Select
              labelId="langFilterLabel"
              id="langFilter"
              value={lang}
              onChange={handleLangChange}
              autoWidth
              label={t("commonItems.dropdownLabel_lang")}
            >
              {expertInfo.allTests &&
                expertInfo.allTests.filter(item => item.testId === testId)[0].lang.sort().map((item, i) => {
                  return <MenuItem key={i} value={item}>{expertInfo.allLangs[item]}</MenuItem>   
                })
              }
            </Select>
          </FormControl>
          {tabValue === 0 && 
            <>
              <FormControl sx={{ m: 1, minWidth: 150}}>
                <TextField
                  error = {studentFormError.classId} 
                  helperText = {studentFormError.classId ? "classId must contain only letters and digits with 10 to 32 characters" : false} 
                  autoFocus
                  required
                  // margin="dense"
                  id="classId"
                  name={t("commonItems.textfieldLabel_classId")}
                  label={t("commonItems.textfieldLabel_classId")}
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={studentForm.classId}
                  onChange={(e) => handleStudentFormChange("classId", e.target.value)}
                />
              </FormControl>
              <Button 
                // size="small"
                onClick={handleFetchStudents}
                disabled={studentFormError.classId || studentFormState}
                variant="contained" startIcon={<GroupsIcon />} 
              >
                {t("expert.rateStudents.buttonLabel_fetchStudents")}{studentFormState && <CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/>}
              </Button>
            </>
          }
          {tabValue === 1 && 
            <>
              <FormControl sx={{ m: 1, minWidth: 150}}>
                <TextField
                  error = {studentFormError.orgStudId} 
                  helperText = {studentFormError.orgStudId ? "orgStudId must contain only letters and digits upto 32 characters" : false} 
                  autoFocus
                  required
                  // margin="dense"
                  id="orgStudId"
                  name={t("commonItems.textfieldLabel_orgStudId")}
                  label={t("commonItems.textfieldLabel_orgStudId")}
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={studentForm.orgStudId}
                  onChange={(e) => handleStudentFormChange("orgStudId", e.target.value)}
                />
              </FormControl>
              <Button 
                // size="small"
                onClick={handleClickOpen}
                disabled={studentFormError.orgStudId || studentFormState}
                variant="contained" startIcon={<AssessmentIcon />} 
              >
                {t("expert.rateStudents.buttonLabel_viewReport")}{studentFormState && <CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/>}
              </Button>
            </>
          }
        </div>
      </div>
      {tabValue === 0 && 
        <>
          {Object.keys(studentsData).length !==0 &&
            <>
              <div className="tabs">
                <FormControl sx={{ m: 1, minWidth: 150}} size="small">
                  <InputLabel id="sortByFilterLabel">{t("commonItems.dropdownLabel_sortBy")}</InputLabel>
                  <Select
                    labelId="sortByFilterLabel"
                    id="sortByFilter"
                    value={sortBy}
                    onChange={(e) => setSortByChange(e.target.value)}
                    autoWidth
                    label={t("commonItems.dropdownLabel_sortBy")}
                  >
                    {orderBy &&
                      columns.filter(item => orderBy.includes(item.key)).map((item, i) => {
                        return <MenuItem key={i} value={item.key}>{item.headerName}</MenuItem>   
                      })
                    }
                  </Select>
                </FormControl>
                <p className="fontFamily-Montserrat" style={{placeSelf: "center", marginRight: "auto"}}>
                  Showing student list of <b>Grade {studentsData.grade}, {studentsData.region}</b>
                </p>
              </div>
              <Divider />
              <div className="table">
                <Table
                  columns={columns}
                  tableData={
                    studentsData.students.map(item => {
                      let rated = Object.keys(studentsData.studentRatings).length !==0 ? studentsData.studentRatings[lang]?.includes(item.orgStudId) : false
                      let stats = item.stats
                      return {
                        ...item,
                        "rated": rated ? "Yes" : "No",
                        "testId": testId,
                        "enWcpm": stats?.EN.wcpm,
                        "hiWcpm": stats?.HI.wcpm,
                        "enAccuracy": stats?.EN.accuracy,
                        "hiAccuracy": stats?.HI.accuracy
                      }
                    })
                  }
                  orderBy={sortBy} 
                  sortBy={sortBy}
                  maxRowsPerPage={30}
                  tableHeight="calc(100vh - 390px)"
                />
              </div>
            </>
          }
          {error &&
            <MuiAlert severity={error.status} className="blankScreenError" sx={{borderRadius: "10px"}}>
              <AlertTitle>{error.message}</AlertTitle>
            </MuiAlert>
          }
        </>
      }
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth={true}
        maxWidth={maxWidth}
        scroll="paper"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: 'var(--new-bg-color)',
            borderRadius: '10px'
          }
        }}
      >
        <StudentReport 
          handleClose={handleClose} 
          testId={testId} 
          lang = {lang}
          allLangs={expertInfo.allLangs}
          error={error} 
          reportJson={reportJson} 
          setReportJson={setReportJson}
          studentsData={studentsData} 
          setStudentsData={setStudentsData}
          audioRef={audioRef}
        />
      </Dialog>
    </div>
  )
}

export default StudentRating